/**
 * NativeWaves SMEP API v1
 *
 * Contact: support@nativewaves.com
 *
 * DO NOT EDIT THIS CLASS MANUALLY!
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class WorkspacesApi extends runtime.BaseAPI {
    /**
     * Get a paginated list of workspaces. If the filter: \'query\' is used, then the max total return count is limited to 10 000 even with pagination.
     */
    async workspacesGetRaw(requestParameters, initOverrides) {
        if (requestParameters.environmentId === null ||
            requestParameters.environmentId === undefined) {
            throw new runtime.RequiredError('environmentId', 'Required parameter requestParameters.environmentId was null or undefined when calling workspacesGet.');
        }
        const queryParameters = {};
        if (requestParameters.environmentId !== undefined) {
            queryParameters['environmentId'] = requestParameters.environmentId;
        }
        if (requestParameters.resourceState) {
            queryParameters['resourceState'] = requestParameters.resourceState;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/workspaces`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of workspaces. If the filter: \'query\' is used, then the max total return count is limited to 10 000 even with pagination.
     */
    async workspacesGet(requestParameters, initOverrides) {
        const response = await this.workspacesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new workspace.
     */
    async workspacesPostRaw(requestParameters, initOverrides) {
        if (requestParameters.smepWorkspaceInsert === null ||
            requestParameters.smepWorkspaceInsert === undefined) {
            throw new runtime.RequiredError('smepWorkspaceInsert', 'Required parameter requestParameters.smepWorkspaceInsert was null or undefined when calling workspacesPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/workspaces`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.smepWorkspaceInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new workspace.
     */
    async workspacesPost(requestParameters, initOverrides) {
        const response = await this.workspacesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a workspace.
     */
    async workspacesWorkspaceIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.workspaceId === null ||
            requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId', 'Required parameter requestParameters.workspaceId was null or undefined when calling workspacesWorkspaceIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/workspaces/{workspaceId}`.replace(`{${'workspaceId'}}`, String(requestParameters.workspaceId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a workspace.
     */
    async workspacesWorkspaceIdDelete(requestParameters, initOverrides) {
        await this.workspacesWorkspaceIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a workspace.
     */
    async workspacesWorkspaceIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.workspaceId === null ||
            requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId', 'Required parameter requestParameters.workspaceId was null or undefined when calling workspacesWorkspaceIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/workspaces/{workspaceId}`.replace(`{${'workspaceId'}}`, String(requestParameters.workspaceId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a workspace.
     */
    async workspacesWorkspaceIdGet(requestParameters, initOverrides) {
        const response = await this.workspacesWorkspaceIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of guests.
     */
    async workspacesWorkspaceIdGuestsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.workspaceId === null ||
            requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId', 'Required parameter requestParameters.workspaceId was null or undefined when calling workspacesWorkspaceIdGuestsGet.');
        }
        if (requestParameters.memberType === null ||
            requestParameters.memberType === undefined) {
            throw new runtime.RequiredError('memberType', 'Required parameter requestParameters.memberType was null or undefined when calling workspacesWorkspaceIdGuestsGet.');
        }
        const queryParameters = {};
        if (requestParameters.memberType !== undefined) {
            queryParameters['memberType'] = requestParameters.memberType;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/workspaces/{workspaceId}/guests`.replace(`{${'workspaceId'}}`, String(requestParameters.workspaceId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of guests.
     */
    async workspacesWorkspaceIdGuestsGet(requestParameters, initOverrides) {
        const response = await this.workspacesWorkspaceIdGuestsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a guest.
     */
    async workspacesWorkspaceIdGuestsGuestIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.workspaceId === null ||
            requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId', 'Required parameter requestParameters.workspaceId was null or undefined when calling workspacesWorkspaceIdGuestsGuestIdGet.');
        }
        if (requestParameters.guestId === null ||
            requestParameters.guestId === undefined) {
            throw new runtime.RequiredError('guestId', 'Required parameter requestParameters.guestId was null or undefined when calling workspacesWorkspaceIdGuestsGuestIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/workspaces/{workspaceId}/guests/{guestId}`
                .replace(`{${'workspaceId'}}`, String(requestParameters.workspaceId))
                .replace(`{${'guestId'}}`, String(requestParameters.guestId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a guest.
     */
    async workspacesWorkspaceIdGuestsGuestIdGet(requestParameters, initOverrides) {
        const response = await this.workspacesWorkspaceIdGuestsGuestIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of invitations.
     */
    async workspacesWorkspaceIdInvitationsGetRaw(requestParameters, initOverrides) {
        if (requestParameters.workspaceId === null ||
            requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId', 'Required parameter requestParameters.workspaceId was null or undefined when calling workspacesWorkspaceIdInvitationsGet.');
        }
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/workspaces/{workspaceId}/invitations`.replace(`{${'workspaceId'}}`, String(requestParameters.workspaceId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of invitations.
     */
    async workspacesWorkspaceIdInvitationsGet(requestParameters, initOverrides) {
        const response = await this.workspacesWorkspaceIdInvitationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete an invitation.
     */
    async workspacesWorkspaceIdInvitationsInvitationIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.workspaceId === null ||
            requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId', 'Required parameter requestParameters.workspaceId was null or undefined when calling workspacesWorkspaceIdInvitationsInvitationIdDelete.');
        }
        if (requestParameters.invitationId === null ||
            requestParameters.invitationId === undefined) {
            throw new runtime.RequiredError('invitationId', 'Required parameter requestParameters.invitationId was null or undefined when calling workspacesWorkspaceIdInvitationsInvitationIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/workspaces/{workspaceId}/invitations/{invitationId}`
                .replace(`{${'workspaceId'}}`, String(requestParameters.workspaceId))
                .replace(`{${'invitationId'}}`, String(requestParameters.invitationId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete an invitation.
     */
    async workspacesWorkspaceIdInvitationsInvitationIdDelete(requestParameters, initOverrides) {
        await this.workspacesWorkspaceIdInvitationsInvitationIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get an invitation.
     */
    async workspacesWorkspaceIdInvitationsInvitationIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.workspaceId === null ||
            requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId', 'Required parameter requestParameters.workspaceId was null or undefined when calling workspacesWorkspaceIdInvitationsInvitationIdGet.');
        }
        if (requestParameters.invitationId === null ||
            requestParameters.invitationId === undefined) {
            throw new runtime.RequiredError('invitationId', 'Required parameter requestParameters.invitationId was null or undefined when calling workspacesWorkspaceIdInvitationsInvitationIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/workspaces/{workspaceId}/invitations/{invitationId}`
                .replace(`{${'workspaceId'}}`, String(requestParameters.workspaceId))
                .replace(`{${'invitationId'}}`, String(requestParameters.invitationId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get an invitation.
     */
    async workspacesWorkspaceIdInvitationsInvitationIdGet(requestParameters, initOverrides) {
        const response = await this.workspacesWorkspaceIdInvitationsInvitationIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit an invitation.
     */
    async workspacesWorkspaceIdInvitationsInvitationIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.workspaceId === null ||
            requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId', 'Required parameter requestParameters.workspaceId was null or undefined when calling workspacesWorkspaceIdInvitationsInvitationIdPatch.');
        }
        if (requestParameters.invitationId === null ||
            requestParameters.invitationId === undefined) {
            throw new runtime.RequiredError('invitationId', 'Required parameter requestParameters.invitationId was null or undefined when calling workspacesWorkspaceIdInvitationsInvitationIdPatch.');
        }
        if (requestParameters.smepWorkspaceRoleRamInvitationEdit === null ||
            requestParameters.smepWorkspaceRoleRamInvitationEdit === undefined) {
            throw new runtime.RequiredError('smepWorkspaceRoleRamInvitationEdit', 'Required parameter requestParameters.smepWorkspaceRoleRamInvitationEdit was null or undefined when calling workspacesWorkspaceIdInvitationsInvitationIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/workspaces/{workspaceId}/invitations/{invitationId}`
                .replace(`{${'workspaceId'}}`, String(requestParameters.workspaceId))
                .replace(`{${'invitationId'}}`, String(requestParameters.invitationId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.smepWorkspaceRoleRamInvitationEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit an invitation.
     */
    async workspacesWorkspaceIdInvitationsInvitationIdPatch(requestParameters, initOverrides) {
        const response = await this.workspacesWorkspaceIdInvitationsInvitationIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new invitation.
     */
    async workspacesWorkspaceIdInvitationsPostRaw(requestParameters, initOverrides) {
        if (requestParameters.workspaceId === null ||
            requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId', 'Required parameter requestParameters.workspaceId was null or undefined when calling workspacesWorkspaceIdInvitationsPost.');
        }
        if (requestParameters.smepWorkspaceRoleRamInvitationInsert === null ||
            requestParameters.smepWorkspaceRoleRamInvitationInsert === undefined) {
            throw new runtime.RequiredError('smepWorkspaceRoleRamInvitationInsert', 'Required parameter requestParameters.smepWorkspaceRoleRamInvitationInsert was null or undefined when calling workspacesWorkspaceIdInvitationsPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/workspaces/{workspaceId}/invitations`.replace(`{${'workspaceId'}}`, String(requestParameters.workspaceId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.smepWorkspaceRoleRamInvitationInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new invitation.
     */
    async workspacesWorkspaceIdInvitationsPost(requestParameters, initOverrides) {
        const response = await this.workspacesWorkspaceIdInvitationsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a paginated list of members.
     */
    async workspacesWorkspaceIdMembersGetRaw(requestParameters, initOverrides) {
        if (requestParameters.workspaceId === null ||
            requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId', 'Required parameter requestParameters.workspaceId was null or undefined when calling workspacesWorkspaceIdMembersGet.');
        }
        if (requestParameters.memberType === null ||
            requestParameters.memberType === undefined) {
            throw new runtime.RequiredError('memberType', 'Required parameter requestParameters.memberType was null or undefined when calling workspacesWorkspaceIdMembersGet.');
        }
        const queryParameters = {};
        if (requestParameters.memberType !== undefined) {
            queryParameters['memberType'] = requestParameters.memberType;
        }
        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.next !== undefined) {
            queryParameters['next'] = requestParameters.next;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/workspaces/{workspaceId}/members`.replace(`{${'workspaceId'}}`, String(requestParameters.workspaceId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a paginated list of members.
     */
    async workspacesWorkspaceIdMembersGet(requestParameters, initOverrides) {
        const response = await this.workspacesWorkspaceIdMembersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a member.
     */
    async workspacesWorkspaceIdMembersMemberIdDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters.workspaceId === null ||
            requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId', 'Required parameter requestParameters.workspaceId was null or undefined when calling workspacesWorkspaceIdMembersMemberIdDelete.');
        }
        if (requestParameters.memberId === null ||
            requestParameters.memberId === undefined) {
            throw new runtime.RequiredError('memberId', 'Required parameter requestParameters.memberId was null or undefined when calling workspacesWorkspaceIdMembersMemberIdDelete.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/workspaces/{workspaceId}/members/{memberId}`
                .replace(`{${'workspaceId'}}`, String(requestParameters.workspaceId))
                .replace(`{${'memberId'}}`, String(requestParameters.memberId)),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete a member.
     */
    async workspacesWorkspaceIdMembersMemberIdDelete(requestParameters, initOverrides) {
        await this.workspacesWorkspaceIdMembersMemberIdDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get a member.
     */
    async workspacesWorkspaceIdMembersMemberIdGetRaw(requestParameters, initOverrides) {
        if (requestParameters.workspaceId === null ||
            requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId', 'Required parameter requestParameters.workspaceId was null or undefined when calling workspacesWorkspaceIdMembersMemberIdGet.');
        }
        if (requestParameters.memberId === null ||
            requestParameters.memberId === undefined) {
            throw new runtime.RequiredError('memberId', 'Required parameter requestParameters.memberId was null or undefined when calling workspacesWorkspaceIdMembersMemberIdGet.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/workspaces/{workspaceId}/members/{memberId}`
                .replace(`{${'workspaceId'}}`, String(requestParameters.workspaceId))
                .replace(`{${'memberId'}}`, String(requestParameters.memberId)),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Get a member.
     */
    async workspacesWorkspaceIdMembersMemberIdGet(requestParameters, initOverrides) {
        const response = await this.workspacesWorkspaceIdMembersMemberIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a member.
     */
    async workspacesWorkspaceIdMembersMemberIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.workspaceId === null ||
            requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId', 'Required parameter requestParameters.workspaceId was null or undefined when calling workspacesWorkspaceIdMembersMemberIdPatch.');
        }
        if (requestParameters.memberId === null ||
            requestParameters.memberId === undefined) {
            throw new runtime.RequiredError('memberId', 'Required parameter requestParameters.memberId was null or undefined when calling workspacesWorkspaceIdMembersMemberIdPatch.');
        }
        if (requestParameters.smepWorkspaceRoleRamMemberEdit === null ||
            requestParameters.smepWorkspaceRoleRamMemberEdit === undefined) {
            throw new runtime.RequiredError('smepWorkspaceRoleRamMemberEdit', 'Required parameter requestParameters.smepWorkspaceRoleRamMemberEdit was null or undefined when calling workspacesWorkspaceIdMembersMemberIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/workspaces/{workspaceId}/members/{memberId}`
                .replace(`{${'workspaceId'}}`, String(requestParameters.workspaceId))
                .replace(`{${'memberId'}}`, String(requestParameters.memberId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.smepWorkspaceRoleRamMemberEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a member.
     */
    async workspacesWorkspaceIdMembersMemberIdPatch(requestParameters, initOverrides) {
        const response = await this.workspacesWorkspaceIdMembersMemberIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create a new member.
     */
    async workspacesWorkspaceIdMembersPostRaw(requestParameters, initOverrides) {
        if (requestParameters.workspaceId === null ||
            requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId', 'Required parameter requestParameters.workspaceId was null or undefined when calling workspacesWorkspaceIdMembersPost.');
        }
        if (requestParameters.smepWorkspaceRoleRamMemberInsert === null ||
            requestParameters.smepWorkspaceRoleRamMemberInsert === undefined) {
            throw new runtime.RequiredError('smepWorkspaceRoleRamMemberInsert', 'Required parameter requestParameters.smepWorkspaceRoleRamMemberInsert was null or undefined when calling workspacesWorkspaceIdMembersPost.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/workspaces/{workspaceId}/members`.replace(`{${'workspaceId'}}`, String(requestParameters.workspaceId)),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.smepWorkspaceRoleRamMemberInsert,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Create a new member.
     */
    async workspacesWorkspaceIdMembersPost(requestParameters, initOverrides) {
        const response = await this.workspacesWorkspaceIdMembersPostRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Edit a workspace.
     */
    async workspacesWorkspaceIdPatchRaw(requestParameters, initOverrides) {
        if (requestParameters.workspaceId === null ||
            requestParameters.workspaceId === undefined) {
            throw new runtime.RequiredError('workspaceId', 'Required parameter requestParameters.workspaceId was null or undefined when calling workspacesWorkspaceIdPatch.');
        }
        if (requestParameters.smepWorkspaceEdit === null ||
            requestParameters.smepWorkspaceEdit === undefined) {
            throw new runtime.RequiredError('smepWorkspaceEdit', 'Required parameter requestParameters.smepWorkspaceEdit was null or undefined when calling workspacesWorkspaceIdPatch.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token('AccessToken', []);
            headerParameters['Authorization'] = `Bearer ${tokenString}`;
        }
        const response = await this.request({
            path: `/workspaces/{workspaceId}`.replace(`{${'workspaceId'}}`, String(requestParameters.workspaceId)),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.smepWorkspaceEdit,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }
    /**
     * Edit a workspace.
     */
    async workspacesWorkspaceIdPatch(requestParameters, initOverrides) {
        const response = await this.workspacesWorkspaceIdPatchRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const WorkspacesGetResourceStateEnum = {
    Active: 'ACTIVE',
    Disposed: 'DISPOSED',
    Deleted: 'DELETED',
};
/**
 * @export
 */
export const WorkspacesWorkspaceIdGuestsGetMemberTypeEnum = {
    Team: 'Team',
    User: 'User',
};
/**
 * @export
 */
export const WorkspacesWorkspaceIdMembersGetMemberTypeEnum = {
    Team: 'Team',
    User: 'User',
};
//# sourceMappingURL=WorkspacesApi.js.map